export var HttpMethodType;
(function (HttpMethodType) {
    HttpMethodType["POST"] = "POST";
    HttpMethodType["GET"] = "GET";
    HttpMethodType["PUT"] = "PUT";
    HttpMethodType["DELETE"] = "DELETE";
    HttpMethodType["PATCH"] = "PATCH";
})(HttpMethodType || (HttpMethodType = {}));
//# sourceMappingURL=HttpMethodType.js.map